import React, { useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl/FormikControl'
import { Add, Edit} from '@mui/icons-material';
import systemMasterServices from '../systemMasterServices';
import { useAppData } from '../../../context/AppDataContext';
import { useAlert } from '../../../context/AlertContext';

export default function InlineSystemMasterForm({masterName,data,callBack}) {
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const {getMasterList} = useAppData();
    const {AppAlert} = useAlert();

    const initialValues = {
        title: "",
        masterName:masterName
    }

    const onSubmit = (values, onSubmitProps) => {
        setSavingStatus(true)
        systemMasterServices.save(values).then(res =>{
            AppAlert(res.msg)
            getMasterList();
            setDialogStatus(false);
            if(callBack){
                callBack(res.id)
            }
        }).catch(error=>{
            console.log("error",error);
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    const validationRule = Yup.object({
        title: Yup.string().required("Required"),
    });

    const addNew = ()=>{
        let autoFill = {
            title:"",
            masterName:masterName
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            title:data.title,
            masterName:masterName
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }
    const handleClose  = () =>{
        setDialogStatus(false);
    }
    return (
        <>
            {!data && 
                <Tooltip title={"Add New "+masterName.replace("-"," ").toUpperCase()}>
                    <IconButton onClick={addNew} style={{padding:"0px"}}>
                        <Add/>
                    </IconButton>
                </Tooltip>    
            }
            {data && 
                <Tooltip title={"Update "+masterName.replace("-"," ").toUpperCase()}>
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="sm"
            >
                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{data ?  "Update " : "Add New"} <span className='fw-bold'>{masterName.replace("-"," ").toUpperCase()} </span> </DialogTitle>
                                    <DialogContent>
                                        <div className="row p-2">
                                            <FormikControl control="input" formik={formik} 
                                                label="Title" name="title" 
                                                className="col-sm-12 col-xs-12" 
                                            />
                                        </div>

                                        <div className="row">
                                        {   /*JSON.stringify(formik.values) */}
                                        </div>
                                        {savingInProgress && <div className="row"><LinearProgress/></div> }
                                    </DialogContent>
                                    <DialogActions>
                                        {!savingInProgress && 
                                            <>
                                            <button className="btn btn-success" type="submit">Save</button>
                                            <button className="btn btn-danger" type="button" onClick={handleClose}>Cancel</button>
                                            </>
                                        }
                                    </DialogActions>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>
        </>
    )
}